import { z } from 'zod';
export const FamilyStatus = z.enum(['active', 'suspended', 'invited']);
export const FamilyRow = z.object({
    id: z.number().int(),
    name: z.string(),
    email: z.string().email(),
    status: FamilyStatus,
    created_at: z.string(), // ISO string, formatted client-side for display
    last_active_at: z.string().nullable(),
    invite_token: z.string().nullable(),
    invite_expires_at: z.string().nullable(),
});
export const CreateFamilyRequest = z.object({
    name: z.string().min(1).max(120),
    email: z.string().email().max(190),
});
export const UpdateFamilyRequest = z
    .object({
    name: z.string().min(1).max(120).optional(),
    email: z.string().email().max(190).optional(),
    status: FamilyStatus.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
export const InviteVerifyRequest = z.object({
    token: z.string().min(10).max(128),
});
export const InviteVerifyResponse = z.object({
    name: z.string(),
    email: z.string().email(),
});
export const InviteCompleteRequest = z.object({
    token: z.string().min(10).max(128),
    password: z.string().min(6).max(200),
});
